import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
export default {
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.USER_LIST]: (state, payload) => {
		state.users = payload;
		state.groups = [];
		if (state.users != null) {
			state.users.resultList.forEach(row => {
				Object.keys(row).forEach(item => {
					if (item == 'lastLoginDt' || item == 'lastPwdChgDt') {
						let tmpDate = new Date(row[item]);
						row[item] =
							tmpDate.getFullYear() +
							'-' +
							('0' + (tmpDate.getMonth() + 1)).substr(0, 2) +
							'-' +
							('0' + tmpDate.getDate()).substr(0, 2) +
							' ' +
							('0' + tmpDate.getHours()).substr(0, 2) +
							':' +
							('0' + tmpDate.getMinutes()).substr(0, 2) +
							':' +
							('0' + tmpDate.getSeconds()).substr(0, 2);
					}
				});
			});
		}
	}
};
